export { StyledText, variantStyles } from '@rockalingua/ui';
